import React from 'react';
import {svgIconWrapper} from '../svg-icon-wrapper';
import CampaignIconSvg from './icon-campaign.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CampaignIconSvg {...validProps} />;
}
SvgComponent.iconName = 'campaignIcon';

export const CampaignIcon = svgIconWrapper(SvgComponent);
